import { render, staticRenderFns } from "./UserMobileMore.vue?vue&type=template&id=070e4a49&scoped=true&"
import script from "./UserMobileMore.vue?vue&type=script&lang=js&"
export * from "./UserMobileMore.vue?vue&type=script&lang=js&"
import style0 from "./UserMobileMore.vue?vue&type=style&index=0&id=070e4a49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "070e4a49",
  null
  
)

export default component.exports